import {remoteRoutingModule} from "./remoteRoutingModule";

class NlgRemoteRoutingUsageDashboardController {
    dashboardConfiguration = {dashboardSourceId: "gcpOverview"};
}

remoteRoutingModule.directive("nlgRemoteRoutingUsageDashboard", [function () {
    return {
        restrict: "E",
        scope: {},
        controller: NlgRemoteRoutingUsageDashboardController,
        controllerAs: "ctrl",
        template: `<dashboard config="ctrl.dashboardConfiguration" domain="gcp-overview"></dashboard>`
    }
}])